<div class="tabs">
    @for (tab of tabs(); track tab.id; let index = $index) {
        <div
            class="tab"
            [class.active]="selectedTabIndex() === index"
            (click)="selectedTabIndex.set(index); tabClicked.emit(tab)">
            @if (tab.iconKey) {
                <svg
                    class="tab-icon"
                    [attr.width]="tab.iconSize ?? 12"
                    [attr.height]="tab.iconSize ?? 12">
                    <use [attr.xlink:href]="'assets/icons/icons-sprite.svg#' + tab.iconKey"></use>
                </svg>
            }
            <span class="tab-label">{{ tab.label }}</span>
        </div>
    }
</div>
